import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { Button } from '../../../components/ui/button';

interface ConnectedAccountProps {
  name: string | null | undefined;
  email: string | null | undefined;
  onDisconnect: () => void;
  icon?: string;
}

const ConnectedAccount: React.FC<ConnectedAccountProps> = ({
  name,
  email,
  onDisconnect,
  icon,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between p-3 bg-background border rounded-lg">
      <div className="flex items-center gap-3">
        {icon && (
          <div className="flex items-center justify-center w-8 h-8">
            <img src={icon} alt="" className="w-6 h-6" />
          </div>
        )}
        <div className="flex flex-col">
          <span className="text-xs text-muted-foreground">
            {t('settings.meetingBot.connected', 'Connected')}
          </span>
          <span className="text-sm font-medium">{name || 'Unknown'}</span>
          <span className="text-xs text-muted-foreground">{email || ''}</span>
        </div>
      </div>
      <Button
        variant="ghost"
        size="icon"
        onClick={onDisconnect}
        className="h-8 w-8 text-muted-foreground hover:text-destructive hover:bg-destructive/10"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ConnectedAccount;
